import React, { useState, useEffect } from 'react';
import './BootScreen.css';

const BootScreen = ({ onFinish }) => {
    const [progress, setProgress] = useState(0);
    const messages = [
        "Loading Findows 2000™...",
        "1000% LEGIMATE LICENSE DICK™...",
        "LOADING SPLONKY DISK™...",
        "DEPLOYING FINTECH HYPERDRIVE...",
        "SPLONIATE LICENSE KEY™...",
        "CATASTROPHIC WOBBLE DETECTED...",
        "STOCK MARKET STABILITY: QUESTIONABLE...",
        "INITIALIZING TRADE SYSTEM...",
        "BOOTING QUANTUM LEDGER PROTOCOL™...",
        "ACTIVATING FINTECH OVERLORD AI...",
        "LOADING NFT STOCK REINFORCER™...",
        "DASHBOARD DEPLOYMENT IN PROGRESS...",
        "BOOT SEQUENCE COMPLETE. PLEASE STAND BY..."
    ];
    

    useEffect(() => {
        let interval = setInterval(() => {
            setProgress(prev => {
                if (prev >= 100) {
                    clearInterval(interval);
                    setTimeout(onFinish, 1200); // Small delay before showing dashboard
                    return 100;
                }
                return prev + Math.random() * 12; // Randomized speed
            });
        }, 300);

        return () => clearInterval(interval);
    }, [onFinish]);

    return (
        <div className="boot-screen">
            {/* Scanline Overlay */}
            <div className="scanline-overlay"></div>
    
            <div className="boot-content">
                <h1>Findows 2000™</h1>
                <div className="progress-bar">
                    <div className="progress-fill" style={{ width: `${progress}%` }}></div>
                </div>
                <p className="boot-message">
                    {messages[Math.floor((progress / 100) * messages.length)]}
                </p>
            </div>
        </div>
    );
    
};

export default BootScreen;
//©Vant